module.exports = __webpack_public_path__ + "img/05.7776a7b1.png";